import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { NotificationService } from '../notification.service';
import { Notification } from './../notification';

class NotificationVM extends Notification {
  id: number;
}

@Component({
  selector: 'bom-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('simpleFadeAnimation', [
      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [style({ opacity: 0 }), animate(300)]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave', animate(600, style({ opacity: 0 }))),
    ]),
  ],
})
export class NotificationComponent implements OnInit, OnDestroy {
  id = 0;
  notifications: NotificationVM[] = [];

  // Default options
  options = {
    hideDelay: 5000,
    hideOnClick: true,
  };

  componentDestroyed$ = new Subject<any>();

  constructor(
    private notificationService: NotificationService,
    private changeRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.notificationService.notifications$
      .pipe(
        takeUntil(this.componentDestroyed$),
        map(notification => {
          const vm = notification as NotificationVM;
          vm.id = this.id;
          this.id = this.id + 1;
          return vm;
        })
      )
      .subscribe((notification: NotificationVM) => {
        this.notifications = [notification, ...this.notifications];
        this.changeRef.detectChanges();

        this.hideAfterDelay(notification);
      });
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }

  handleNotificationClick(notification: NotificationVM) {
    // override default options with notification options
    const options = Object.assign({}, this.options, notification);

    if (options.hideOnClick) {
      this.hideNotification(notification);
    }
  }

  private hideAfterDelay(notification: NotificationVM) {
    // override default options with notification options
    const options = Object.assign({}, this.options, notification);

    setTimeout(() => {
      this.hideNotification(notification);
    }, options.hideDelay);
  }

  private hideNotification(notification: NotificationVM) {
    const index = this.notifications.findIndex(n => n.id === notification.id);
    this.notifications.splice(index, 1);
    this.changeRef.detectChanges();
  }
}
